export const five_frame_formations = [
  [
    [0, 0, 0, 0, 0],
  ],
  [
    [1, 0, 0, 0, 0],
  ],
  [
    [1, 1, 0, 0, 0],
  ],
  [
    [1, 1, 1, 0, 0],
  ],
  [
    [1, 1, 1, 1, 0],
  ],
  [
    [1, 1, 1, 1, 1],
  ],
];
